export default __webpack_public_path__ + "static/media/oxetechlab_person_recortado.f480499e.png";